import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { fetchGroupFiles, fetchMyCloud, fetchMyUpload, fetchSecretFolder, fetchFileMetadata, fetchRoamingInfo } from '@kso/ui/lib/request';
import KMessage from '@kso/ui/lib/utils/message';
import UA from '@kso/ui/lib/utils/ua';
import { toHomeByPath, closePage } from '@kso/sdk-super/lib/mdocs';
import { toastError, openLink } from '@kso/ui/lib/utils';
import { replaceOpenHref } from '@kso/constants';

function ignoreError(_x, _x2) {
  return _ignoreError.apply(this, arguments);
}
function _ignoreError() {
  _ignoreError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fun, params) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fun(params);
        case 3:
          _context.t0 = _context.sent;
          if (_context.t0) {
            _context.next = 6;
            break;
          }
          _context.t0 = {};
        case 6:
          return _context.abrupt("return", _context.t0);
        case 9:
          _context.prev = 9;
          _context.t1 = _context["catch"](0);
          return _context.abrupt("return", {});
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9]]);
  }));
  return _ignoreError.apply(this, arguments);
}
function index () {
  return _ref.apply(this, arguments);
}
function _ref() {
  _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var params,
      url,
      fileid,
      folderLink,
      onlyReturnPath,
      throwErr,
      fileInfo,
      _yield$fetchFileMetad,
      fileinfo,
      _fileInfo,
      groupid,
      parentid,
      mySecret,
      myUpload,
      myCloud,
      currentTeam,
      roamingInfo,
      win,
      wxpcmini,
      qqpcmini,
      wpsmac,
      browser,
      mdocs,
      myun,
      mWOA,
      isTablet,
      woa,
      kdesktop,
      isTabletClient,
      isFirefox,
      isSafari,
      name,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          fileid = params.fileid, folderLink = params.folderLink, onlyReturnPath = params.onlyReturnPath, throwErr = params.throwErr;
          _context2.prev = 2;
          _context2.next = 5;
          return fetchFileMetadata(fileid);
        case 5:
          _yield$fetchFileMetad = _context2.sent;
          fileinfo = _yield$fetchFileMetad.fileinfo;
          fileInfo = fileinfo;
          _context2.next = 18;
          break;
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](2);
          if (!throwErr) {
            _context2.next = 16;
            break;
          }
          throw _context2.t0;
        case 16:
          toastError(_context2.t0);
        case 17:
          return _context2.abrupt("return");
        case 18:
          _fileInfo = fileInfo, groupid = _fileInfo.groupid, parentid = _fileInfo.parentid;
          mySecret = {};
          myUpload = {};
          myCloud = {};
          currentTeam = {};
          roamingInfo = {};
          if (folderLink) {
            _context2.next = 44;
            break;
          }
          _context2.t1 = Promise;
          _context2.next = 28;
          return ignoreError(fetchSecretFolder);
        case 28:
          _context2.t2 = mySecret = _context2.sent;
          _context2.next = 31;
          return ignoreError(fetchMyUpload);
        case 31:
          _context2.t3 = myUpload = _context2.sent;
          _context2.next = 34;
          return ignoreError(fetchMyCloud);
        case 34:
          _context2.t4 = myCloud = _context2.sent;
          _context2.next = 37;
          return ignoreError(fetchGroupFiles, groupid);
        case 37:
          _context2.t5 = currentTeam = _context2.sent;
          _context2.next = 40;
          return ignoreError(fetchRoamingInfo, fileid);
        case 40:
          _context2.t6 = roamingInfo = _context2.sent;
          _context2.t7 = [_context2.t2, _context2.t3, _context2.t4, _context2.t5, _context2.t6];
          _context2.next = 44;
          return _context2.t1.all.call(_context2.t1, _context2.t7);
        case 44:
          if (!(!folderLink && currentTeam.group_type && !['normal', 'team', 'special', 'tmp', 'secret', 'corpnormal', 'corpindex', 'corpspecial', 'corptmp', 'corpdep'].includes(currentTeam.group_type))) {
            _context2.next = 47;
            break;
          }
          KMessage.error('暂不支持打开该文件位置');
          return _context2.abrupt("return");
        case 47:
          wxpcmini = UA.wxpcmini, qqpcmini = UA.qqpcmini, wpsmac = UA.wpsmac, browser = UA.browser, mdocs = UA.mdocs, myun = UA.myun, mWOA = UA.mWOA, isTablet = UA.isTablet, woa = UA.woa, kdesktop = UA.kdesktop, isTabletClient = UA.isTabletClient, isFirefox = UA.isFirefox;
          isSafari = browser === 'Safari';
          if (!wpsmac && !wxpcmini && !qqpcmini && !onlyReturnPath && !isSafari && !woa && !kdesktop) {
            win = window.open();
          }
          // 分享文件夹
          if (folderLink) {
            url = "/fl/".concat(folderLink);
          } else if (parseInt(groupid) === mySecret.id) {
            // 私密文件夹
            if (parentid) {
              url = "/secret/".concat(groupid, "/").concat(parentid);
            } else {
              url = '/secret';
            }
          } else if (!currentTeam.user_role) {
            // 共享文件夹
            url = '/sharing/received';
          } else if (parseInt(groupid) === myUpload.id && !myUpload.corpid) {
            // 云端备份文件
            // 如果存在我的设备信息，则跳转到我的设备对应文件夹
            if (roamingInfo.device_info && roamingInfo.device_info.id) {
              url = "/device/".concat(roamingInfo.device_info.id);
            } else {
              url = '/devices';
            }
          } else {
            if (currentTeam.corpid) {
              // 企业文件
              name = 'ent';
              if (currentTeam.group_type === 'corpspecial') {
                name = 'space';
              }
              if (currentTeam.group_type === 'corptmp') {
                name = 'backup';
              }
              url = "/".concat(name, "/").concat(currentTeam.corpid, "/").concat(groupid, "/").concat(parentid);
            } else if (groupid === myCloud.id) {
              if (parentid) {
                // 个人文件
                url = "/mine/".concat(parentid);
              } else {
                // 我的文档
                url = '/?show=all';
              }
            } else {
              // 个人团队文件/共享文件夹
              url = "/team/".concat(groupid, "/").concat(parentid);
            }
          }
          if (/show=all/.test(url)) {
            url += "&count=60&fileId=".concat(fileid);
          } else {
            url += "?count=60&fileId=".concat(fileid);
          }
          window.yunSelected = [fileid];

          // 只返回路径，调用方自行处理后续
          if (!onlyReturnPath) {
            _context2.next = 55;
            break;
          }
          return _context2.abrupt("return", replaceOpenHref(url));
        case 55:
          if (isTabletClient) {
            toHomeByPath({
              homeUrl: url
            });
          } else if (mdocs || myun || mWOA) {
            closePage({
              url: url,
              needTitleBar: false
            });
          } else if (win && win.location) {
            win.location.href = replaceOpenHref(url);
          } else if (isTablet || isSafari) {
            try {
              if (window.top) {
                // 4大组件下是iframe的场景
                window.top.location.href = replaceOpenHref(url);
              } else {
                window.location.href = replaceOpenHref(url);
              }
            } catch (err) {
              console.log(err);
            }
          } else if (qqpcmini) {
            openLink(replaceOpenHref("".concat(window.origin).concat(url)));
          } else {
            if (isFirefox) {
              window.location.href = replaceOpenHref(url);
            } else {
              window.open(replaceOpenHref(url));
            }
          }
        case 56:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 10]]);
  }));
  return _ref.apply(this, arguments);
}

export { index as default };
